import React from 'react';
import Header from '../../components/header/header.component';
import Footer from '../../components/footer/footer.component';
import { Row, Col } from 'antd';
import popup from '../../assets/images/popup.jpeg';

const privacyPolicy = () => {
  return (
    <div className="header2">
      <Header />
      <div className="offers_page hero lft-rght-padding">

        <h2 className="text-center" style={{ color: "rgb(0, 140, 211)", fontWeight: "700" }}>End of the month discount offer</h2>
        <hr></hr>
        <Row className="col_reverse">
          <Col sm={24} md={16} >
            <h3>Get up to 12% OFF* on Medicines * Limited time offer</h3>
            <p>From 26th June to 15th of July 2021, get up to 12% OFF* (max. discount Rs 1200) on medicine orders *Min. order Rs 5000.</p>

            <ul>
              <li>
                ELIGIBILITY ALL Customers, with a total medicine bill of Rs 5000/- and above. Please Note: This offer is NOT valid for (Any Ayurvedic medicines, OTC & FMCG products).
              </li>
            </ul>


            <h3>HOW DO YOU GET IT?</h3>
            <p>Place an order through whatsaap or the Dawa Asaan application to avail discounts through this offer.  </p>
            <h3>CONDITIONS IN CASE OF CANCELLATION:</h3>
            <p>Note: If your order is cancelled, this offer will become null and void. </p>



          </Col>
          <Col sm={24} md={8} >
            <img src={popup} style={{ width: "100%", height: 'auto' }} />
          </Col>

        </Row>
        <h3 className="text-center" style={{ color: "rgb(0, 140, 211)", fontWeight: "700" }}>Terms and Conditions</h3>

        <h3>Flat 12% Off on Medicines Only: Offer Outline </h3>
        <p>Subject to the following Terms and Conditions, from 26th of June to the 15th of July 2021, ALL customers will be eligible to receive upto 12% discount (max. Rs. 1500) immediately on an order of Medicines. NOTE: A minimum order of medicines worth Rs. 5000 is required to be eligible for the 12% discount on medicines.
        </p>
        <h3>How the Offer Works:</h3>
        <p><u>Step 1:</u> Place your medicine order using the Dawa Asaan application or send us your prescription on the Dawa Asaan mobile number, valid from the 26th of June to the 15th of July 2021. NOTE: A minimum order of medicines worth Rs. 5000 is required to be eligible for the  12% discount on medicines.</p>
        <p><u>Step 2:</u> You get an immediate 12% discount (max. Rs. 1500) on medicines, upon check out.<br />

          <strong>For other details, please read the terms and conditions below. </strong>
        </p>



        <h3>Terms and Conditions – upto 12% OFF on Medicines
        </h3>
        <h3>Offer Period:</h3>
        <p> 26th of June – 15th of July 2021</p>
        <h3>Coupon code:</h3>
        <p>   None needed applicable to all order with a bill of Rs 5000/- and above.</p>
        <h3>Offer Includes:</h3>
        <p>	Upto 12% discount* (max Rs.1500) on any order of  Medicines. To get a 12% discount on Medicines, a minimum order of Rs. 5000 worth of medicines is required.</p>
        <h3>Offer Details:</h3>
        <ul>

          <li>	*The maximum discount on medicines per order transaction is capped at Rs. 1500.</li>
          <li>	The coupon code Example must be applied at the shopping cart page to get a FLAT 12% discount on medicines.</li>
          <li>	The flat 12% discount is valid on all medicine orders with a total bill of Rs 5000/- and above. </li>
          <li>	If the order has both prescription medicines and non-prescription products, then the Flat 12% discount will be applicable on the total value of the prescription medicines ONLY (excluding ALL Ayurvedic medicines, OTC & FMCG products).</li>
          <li>	This offer is also NOT applicable on ALL Ayurvedic medicines, over-the-counter and FMCG products.</li>
          <li>	This offer is active for Existing as well as New Customers.</li>
          <li>	This offer cannot be combined with other existing offers.</li>
          <li>	This offer is valid on orders placed via the Dawa Asaan app or sent to Dawa Asaan on whatsaap.</li>
          <li>	This offer cannot be applied to previous purchases.</li>
          <li>	This offer is not redeemable for cash or credit, and cannot be exchanged for any other product. </li>
        </ul>

        <h3> Other Terms and Conditions</h3>
        <ul>
          <li>	This offer is non-negotiable and non-binding.</li>
          <li>	This offer will become null and void in the event that an order placed using the promotional coupon code is cancelled.</li>
          <li>	DawaAsaan.com reserves the right to cancel, change or substitute this offer at any time without prior notice and the same is at the sole discretion of the company.</li>
          <li>	DawaAsaan.com reserves the right to withdraw the DawaAsaan wallet SuperCash from customers’ wallet account if any fraudulent activity is identified for the sake of availing the benefits under the offer.</li>
          <li>	DawaAsaan.com is not responsible for any failed transactions as part of this offer NOR liable for any failures relating to technical, hardware, software, server, website, or other issues of any kind to the extent that these may prevent the Customer from participating in this offer.</li>
          <li>	Dawa Asaan’ decision shall be final and binding in all respects with respect to the matters relating to the offer.</li>
        </ul>
        <h5>Note: By availing this offer, it is deemed that the customer has agreed to all the terms & conditions mentioned herein. </h5>

      </div>
      <Footer />
    </div>

  )
}
export default privacyPolicy;